// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import paymentSuccessSVG from '../../../../assets/img/payment-success.svg';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import {Typography} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import {useHistory} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions as CheckoutActions} from '../../duck';
import queryString from 'query-string';
import {useState} from 'react';
import {useEffect} from 'react';
import analytics from '../../../../analytics';
import LoadingSpinner from '../../../../elements/LoadingSpinner/LoadingSpinner';

import type {
  Store,
  User,
  Subscription,
  SubscriptionSetting,
} from '../../../../entities';
import type {Dispatch} from 'redux';
import type {RootState} from '../../../index';
import {getStringDate} from '../../../../utils/date';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
    subscribeSuccess: state.checkout.subscribeSuccess,
    // subscription: state.tiersList.currentSubscription,
    subscription: state.tiersList.nextSubscription,
    subscriptionSetting: state.accountConfig.subscriptionSetting,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...CheckoutActions,
      },
      dispatch
    )
)(PaymentSuccessModal);

type Props = {|
  user?: User,
  store?: Store,
  subscribeSuccess?: boolean,
  checkoutResetState: () => void,
  subscription?: Subscription,
  subscriptionSetting?: SubscriptionSetting,
|};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 364,
    maxWidth: '100%',
    padding: theme.spacing(5, 2),
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 600,
    marginTop: theme.spacing(1),
    '& span': {
      color: colors.purple,
    },
  },
  text: {
    marginTop: theme.spacing(3),
    color: colors.grey800,
    fontSize: '1.125rem',
  },
  bold: {fontWeight: 600},
  mainContent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(3),
  },
  button: {
    height: 48,
    // borderRadius: '8px',
    marginTop: theme.spacing(4),
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: '4px 80px',
    maxWidth: '100%',
  },
}));

function PaymentSuccessModal(props: Props) {
  const {
    user,
    store,
    subscribeSuccess,
    checkoutResetState,
    subscription,
    subscriptionSetting,
  } = props;

  const classes = useStyles();

  const history = useHistory();
  const queryObject = queryString.parse(history.location.search);

  const [loading, setLoading] = useState(false);

  const [paymentSuccessModal, setPaymentSuccessModal] = useState(false);
  const handleClosePaymentSuccessModal = () => {
    history.replace({search: ''});
    setPaymentSuccessModal(false);
    checkoutResetState();
    history.push('/');
  };

  const paymentSuccess =
    //generic
    // subscribeSuccess ||
    //payU
    (queryObject.merchantId &&
      queryObject.merchant_name &&
      queryObject.transactionState === '4' &&
      queryObject.referenceCode &&
      queryObject.polResponseCode === '1' &&
      queryObject.signature) ||
    // Stripe custom implementation
    (queryObject.payment_intent &&
      queryObject.payment_intent_client_secret &&
      queryObject.redirect_status === 'succeeded') ||
    // Stripe prebuilt checkout
    // || queryObject.stripePaymentSuccess
    // Change to pro+ plan directly with instant subscription
    (subscribeSuccess &&
      subscription &&
      subscriptionSetting &&
      subscriptionSetting.storeTierPlan &&
      subscriptionSetting.storeTierPlan.storeTier.name ===
        subscription.storeTierPlan.storeTier.name);

  useEffect(() => {
    if (paymentSuccess && store) {
      setLoading(true);
      if (store.storeTier.name >= 'TIER_3' || subscribeSuccess) {
        setLoading(false);
        setPaymentSuccessModal(true);
        if (
          ['TIER_3', 'TIER_31', 'TIER_309', 'TIER_310', 'TIER_320'].includes(
            store.storeTier.name
          )
        )
          analytics.fireCustomEvent('Pro Plan Payment Succeeded', undefined, [
            'user-guiding',
          ]);
        else if (store.storeTier.name === 'TIER_31')
          analytics.fireCustomEvent(
            'Free Trial Subscription Succeeded',
            undefined,
            ['user-guiding']
          );
      } else {
        setTimeout(() => {
          window.location.reload(false);
        }, 2000);
      }
    }
  }, [paymentSuccess, store, subscribeSuccess]);

  const handleClickConfirm = () => {
    handleClosePaymentSuccessModal();
  };

  if (loading) return <LoadingSpinner />;
  return (
    <CustomModal
      open={paymentSuccessModal}
      handleCloseModal={handleClosePaymentSuccessModal}
    >
      <div className={classes.root}>
        <img src={paymentSuccessSVG} alt="" />
        <Typography className={classes.title} align="center">
          <span>{user ? user.firstName : ''}</span>
          {user && <br />}
          Tu suscripción fue habilitada.
        </Typography>
        {store && subscription && (
          <div className={classes.mainContent}>
            <Typography>
              <span className={classes.bold}>Plan: </span>{' '}
              {`${
                {TIER_309: 'Básico', TIER_310: 'Básico', TIER_320: 'PRO+'}[
                  store.storeTier.name
                ]
              } - ${
                {MONTHLY: 'Mensual', QUARTERLY: 'Trimestral', ANNUAL: 'Anual'}[
                  subscription.storeTierPlan.frequency.name
                ]
              }`}
            </Typography>
            <Typography>
              <span className={classes.bold}>Fecha de inicio: </span>{' '}
              {getStringDate(subscription.startDate)}
            </Typography>
            <Typography>
              <span className={classes.bold}>Fecha de fin: </span>{' '}
              {getStringDate(subscription.endDate)}
            </Typography>
          </div>
        )}
        <CustomButton
          variant="contained"
          className={classes.button}
          onClick={handleClickConfirm}
        >
          Cerrar
        </CustomButton>
      </div>
    </CustomModal>
  );
}

PaymentSuccessModal.propTypes = {
  user: PropTypes.object,
  store: PropTypes.object,
  subscribeSuccess: PropTypes.bool,
  checkoutResetState: PropTypes.func.isRequired,
  subscription: PropTypes.object,
  subscriptionSetting: PropTypes.object,
};
